import React from "react";
import { DataTable } from "./DataTable";
import { Button } from "antd";
import { YhBox } from "@/components/YhBox";
import { useSgpModel } from "../sgpModel";
import { YhAuth } from "@/components/auth/YhAuth";
import { ResourceAuthEnum } from "@/types/AppResourceAuthEnum";

export const DataBox = () => {
    const { exportSgp } = useSgpModel();

    const action = <>
        <YhAuth resCode={ResourceAuthEnum.G_A_EX}>
            <Button
                className="mr-5"
                type="link"
                shape="round"
                onClick={() => exportSgp()}
            >导出</Button>
        </YhAuth>
    </>;

    return (
        <YhBox title="" action={action}>
            <DataTable />
        </YhBox>
    )
}